import React from "react";
import "./Loader.css";

/**
 * Global loading indicator — a Treasury-branded ring spinner
 * (emerald track, gold arc) over a soft blurred backdrop.
 */
const Loading = () => (
	<div className="trs-loading-backdrop" role="status" aria-label="Loading">
		<div className="trs-spinner">
			<div className="trs-spinner-ring" />
			<div className="trs-spinner-logo">T</div>
		</div>
	</div>
);

export default Loading;
